import { render, staticRenderFns } from "./createAndEdit.vue?vue&type=template&id=bebd7ccc&scoped=true"
import script from "./createAndEdit.vue?vue&type=script&lang=js"
export * from "./createAndEdit.vue?vue&type=script&lang=js"
import style0 from "./createAndEdit.vue?vue&type=style&index=0&id=bebd7ccc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bebd7ccc",
  null
  
)

export default component.exports